// extracted by mini-css-extract-plugin
export var button = "_5c-7";
export var buttonRow = "_5c-6";
export var fadeIn = "_5c-1";
export var gradient = "_5c-0";
export var panel = "_5c-2";
export var panelIn = "_5c-3";
export var subtitle = "_5c-5";
export var title = "_5c-4";